module.exports = __webpack_public_path__ + "static/media/Y10.6fee3d1a.mp3";